const gtag = window.__GA || (() => 0)

export function trackPage(pathname) {
  gtag('config', 'UA-113223352-3', { page_path: pathname })
}

export function trackEvent(category, action, label) {
  gtag('event', action, {
    event_category: category,
    event_label: label,
  })
}



// WEBPACK FOOTER //
// ./src/app/ga.js